import React, { Component } from "react";
import LoanSarvSuraksha from "./loanSarvSuraksha";
import InputForm from "../../html/inputForm";
import SelectForm from "../../html/selectForm";
import ModalPopUp from "../modalPopUp";
import commonContext, { AppContext } from "../../../context/common";
import Relation from "../../../constents/relation";
import { leadType } from "../../../../app";
import { Utilities } from "../../../utils/utilities";
import V from "../../../constents/validation";

interface IProps {}
interface IState {
    sarvSurakshaPopupSwitch: boolean;
    sarvSurakshaFormSwitch: boolean;
}

export class LoanDetailsForm extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    setLeadError: Function;
    base: String;
    apis: any;
    utils: Utilities;

    constructor(props: IProps) {
        super(props);
        this.state = {
            sarvSurakshaPopupSwitch: false,
            sarvSurakshaFormSwitch: true,
        };
    }
    componentDidMount() {
        this.setLead = (this.context as AppContext).setLead;
        this.setLeadError = (this.context as AppContext).setLeadError;
        this.base = (this.context as AppContext).base;
        this.apis = (this.context as AppContext).apis;
        this.utils = (this.context as AppContext).utils as Utilities;
    }
    handleOnChange = (e: any) => {
        let state = {};
        state[e.target.name] = e.target.value;
        this.setLead(state);
    };
    handleForCalEmiAmount = async (e) => {
        this.lead = (this.context as AppContext).lead as leadType;
        let apiDataInterestRate: { result?: { interestRate: any } } = {};
        if (this.base == "dd-al") {
            apiDataInterestRate = {
                result: { interestRate: this.lead.interestRate },
            };
        } else {
            apiDataInterestRate = await this.apis.getInterestRateMaster({
                ...this.lead,
                loanAmount: e.target.value ? parseFloat(e.target.value) : 0,
                tenure: parseFloat(this.lead.tenure),
            });
        }
        const emi = this.utils.getEmi(
            apiDataInterestRate.result?.interestRate,
            e.target.value,
            this.lead.tenure
        );
        let apisDatagetStampDuty = await this.apis.getStampDuty({
            ...this.lead,
            tenure: this.lead.liTenure,
            loanAmount: e.target.value,
            state: this.lead.pdPresentState,
            city: this.lead.pdPresentCity,
            type: "sd",
        });
        let totalLoanAmount =
            parseFloat(e.target.value) +
            (this.lead.insuranceAvailed
                ? parseFloat(this.lead.insuranceSsiPremium)
                : 0) +
            (this.lead.roadTaxInsuranceAvailed
                ? parseFloat(this.lead.rtoEditAmount)
                : 0) +
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) +
            (this.lead.dealerInsuranceAvailed
                ? parseFloat(this.lead.dealerInsuranceAmtEdit)
                : 0);
        let liLoanAmount =
            totalLoanAmount -
            parseFloat(
                apisDatagetStampDuty?.result
                    ? apisDatagetStampDuty.result?.stampDuty
                    : 0
            ) -
            parseFloat(this.lead.processingFees) -
            this.lead.collateralCharges -
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) -
            (this.lead.insuranceAvailed
                ? parseFloat(this.lead.insuranceSsiPremium)
                : 0);
        let marginMoneyPaid =
            parseFloat(this.lead.finalCarPrice) - parseFloat(e.target.value);

        this.setLead({
            loanAmtSelectedByUser: e.target.value,
            desiredLoanAmount: e.target.value,
            emi,
            totalLoanAmount,
            liLoanAmount,
            marginMoneyPaid,
            stampDuty: parseFloat(
                apisDatagetStampDuty?.result
                    ? apisDatagetStampDuty.result?.stampDuty
                    : 0
            ),
            interestRate: apiDataInterestRate.result?.interestRate,
        });
    };
    handleForCalEmiTenure = async (e) => {
        this.lead = (this.context as AppContext).lead as leadType;
        this.base = (this.context as AppContext).base;
        let desiredLoanAmount = this.utils.getFinalPrice(
            e.target.value,
            this.lead.upto36m,
            this.lead.M37_60,
            this.lead.M61_84,
            this.lead.finalCarPrice,
            this.lead.loanAmt
        );
        const apiDataInterestRate = await this.apis.getInterestRateMaster({
            ...this.lead,
            loanAmount: desiredLoanAmount,
            tenure: parseFloat(e.target.value),
        });
        const emi = this.utils.getEmi(
            apiDataInterestRate.result?.interestRate,
            desiredLoanAmount,
            e.target.value
        );
        let apisDatagetStampDuty;
        if (this.base == "zd-10-seconds" || this.base == "qm-10-seconds") {
            apisDatagetStampDuty = await this.apis.getStampDuty({
                ...this.lead,
                tenure: e.target.value,
                loanAmount: desiredLoanAmount,
                type: "sd",
            });
        }

        const apiDataServ = await this.apis.getSarvSurakshaPremium({
            ...this.lead,
            tenure: (e.target.value as unknown) as number,
        });
        let totalLoanAmount =
            desiredLoanAmount +
            (parseFloat(e.target.value) < 61
                ? parseFloat(apiDataServ.result.premium)
                : 0) +
            (this.lead.roadTaxInsuranceAvailed
                ? parseFloat(this.lead.rtoEditAmount)
                : 0) +
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) +
            (this.lead.dealerInsuranceAvailed
                ? parseFloat(this.lead.dealerInsuranceAmtEdit)
                : 0);
        let liLoanAmount =
            totalLoanAmount -
            parseFloat(
                apisDatagetStampDuty?.result
                    ? apisDatagetStampDuty.result?.stampDuty
                    : 0
            ) -
            parseFloat(this.lead.processingFees) -
            this.lead.collateralCharges -
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) -
            (parseFloat(e.target.value) < 61
                ? parseFloat(apiDataServ.result.premium)
                : 0);
        let marginMoneyPaid =
            parseFloat(this.lead.finalCarPrice) - desiredLoanAmount;
        this.setLead({
            loanAmtSelectedByUser: desiredLoanAmount,
            emi,
            desiredLoanAmount,
            totalLoanAmount,
            liLoanAmount,
            marginMoneyPaid,
            stampDuty: parseFloat(
                apisDatagetStampDuty?.result
                    ? apisDatagetStampDuty.result?.stampDuty
                    : 0
            ),
            insuranceAvailed: parseFloat(e.target.value) > 60 ? false : true,
            insuranceSsiPremium:
                parseFloat(e.target.value) < 61
                    ? parseFloat(apiDataServ.result.premium)
                    : 0,
            interestRate: apiDataInterestRate.result?.interestRate,
        });
    };
    handelOnChangeServSuraksha = (servSuraksha) => {
        this.lead = (this.context as AppContext).lead as leadType;
        let totalLoanAmount =
            parseFloat(this.lead.desiredLoanAmount) +
            (servSuraksha ? parseFloat(this.lead.insuranceSsiPremium) : 0) +
            (this.lead.roadTaxInsuranceAvailed
                ? parseFloat(this.lead.rtoEditAmount)
                : 0) +
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) +
            (this.lead.dealerInsuranceAvailed
                ? parseFloat(this.lead.dealerInsuranceAmtEdit)
                : 0);
        let liLoanAmount =
            totalLoanAmount -
            parseFloat(this.lead.stampDuty) -
            parseFloat(this.lead.processingFees) -
            this.lead.collateralCharges -
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) -
            (servSuraksha ? parseFloat(this.lead.insuranceSsiPremium) : 0);
        let marginMoneyPaid =
            parseFloat(this.lead.finalCarPrice) -
            parseFloat(this.lead.desiredLoanAmount);
        this.setLead({
            totalLoanAmount,
            liLoanAmount,
            marginMoneyPaid,
            insuranceAvailed: servSuraksha,
        });
    };
    handleOnChangeSSI = (e) => {
        this.lead = (this.context as AppContext).lead as leadType;
        let totalLoanAmount =
            parseFloat(this.lead.desiredLoanAmount) -
            (this.lead.insuranceAvailed ? parseFloat(e.target.value) : 0);
        let liLoanAmount =
            totalLoanAmount -
            parseFloat(this.lead.stampDuty) -
            parseFloat(this.lead.processingFees) -
            this.lead.collateralCharges;
        let marginMoneyPaid =
            parseFloat(this.lead.finalCarPrice) -
            parseFloat(this.lead.desiredLoanAmount);
        this.setLead({
            totalLoanAmount,
            liLoanAmount,
            marginMoneyPaid,
            insuranceSsiPremium: e.target.value,
        });
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;
        this.base = (this.context as AppContext).base;
        var liTenure = [];
        var monthDiff = this.base == "qm-10-seconds" ? 6 : 12;
        for (var month: number = 12; month <= 84; month = month + monthDiff) {
            if (month <= parseFloat(this.lead.tenure)) {
                liTenure.push({ liTenure: month });
            }
        }
        return (
            <>
                <h1 className="openSans-Reg text-black my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                    Loan Details
                </h1>

                <div className="flex flex-wrap w-full">
                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                        <InputForm
                            label="Desired Amount"
                            prefix="Rs."
                            infoText={`Upto
                                    <span className="WebRupee">
                                        Rs.
                                    </span>
                                    ${this.utils.currencyFormat(
                                        this.lead.desiredLoanAmountUpTo
                                    )}`}
                            name="loanAmtSelectedByUser"
                            handlerOnChange={async (e) => {
                                // this.handleOnChange(e);
                                this.handleOnChange({
                                    target: {
                                        name: "desiredLoanAmount",
                                        value: e.target.value,
                                    },
                                });
                                await this.handleForCalEmiAmount(e);
                                await this.setLeadError(
                                    this.utils.formValidation(
                                        {
                                            ...this.lead,
                                            loanAmtSelectedByUser:
                                                e.target.value,
                                        },
                                        [
                                            V.loanAmtSelectedByUser(
                                                parseFloat(
                                                    this.lead
                                                        .desiredLoanAmountUpTo
                                                )
                                            ),
                                        ]
                                    )
                                );
                            }}
                            value={this.lead.loanAmtSelectedByUser}
                            errorClass="input-info-fix"
                        />
                    </div>
                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                        <SelectForm
                            title="Tenure"
                            noneText="Select Tenure"
                            errorText="Please select Tenure"
                            options={liTenure}
                            name="liTenure"
                            postFix="Months"
                            handlerOnChange={(e) => {
                                this.handleForCalEmiTenure(e);
                            }}
                            value={
                                this.lead.liTenure
                                    ? this.lead.liTenure
                                    : this.lead.tenure
                            }
                            readonly={this.base == "dd-al" ? true : false}
                        />
                    </div>
                    {this.lead.liTenure < 61 ? (
                        <>
                            <div className="w-full">
                                <div className="flex flex-wrap my-3">
                                    <h3 className="openSans-SemiBold text-black text-base md:text-base lg:text-lg xl:text-lg pr-3">
                                        Add Sarv Suraksha Insurance
                                    </h3>
                                    <a
                                        href="javascript:;"
                                        className="modal-open sarva-suraksha-info mr-3"
                                        data-toggle="modal"
                                        data-target="sarvSurakshaModal"
                                        onClick={() =>
                                            this.setState({
                                                sarvSurakshaPopupSwitch: true,
                                            })
                                        }
                                    >
                                        sarva-suraksha-info
                                    </a>
                                    <div className="switch-wrap flex flex-wrap mb-4 ">
                                        <label className="switch mt-1">
                                            <input
                                                type="checkbox"
                                                onChange={async (e) => {
                                                    await this.setLead({
                                                        insuranceAvailed: !this
                                                            .lead
                                                            .insuranceAvailed,
                                                    });
                                                    this.setState({
                                                        sarvSurakshaFormSwitch: !this
                                                            .state
                                                            .sarvSurakshaFormSwitch,
                                                    });
                                                    this.handelOnChangeServSuraksha(
                                                        !this.state
                                                            .sarvSurakshaFormSwitch
                                                    );
                                                }}
                                                checked={
                                                    this.lead.insuranceAvailed
                                                }
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                {this.lead.insuranceAvailed ? (
                                    <>
                                        <div className="sarv-suraksha-calc-wrap flex flex-wrap">
                                            <div className="w-full">
                                                <div className="relative w-full sm:w-1/2 mb-8 lg:mb-10 pr-0 sm:pr-2 md:pr-4">
                                                    <InputForm
                                                        label="Amount"
                                                        prefix="Rs."
                                                        errorText="Please enter amount"
                                                        name="insuranceSsiPremium"
                                                        handlerOnChange={async (
                                                            e
                                                        ) => {
                                                            this.handleOnChangeSSI(
                                                                e
                                                            );
                                                        }}
                                                        value={
                                                            this.lead
                                                                .insuranceSsiPremium
                                                        }
                                                        readonly={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                                <InputForm
                                                    label="Nominee Name"
                                                    errorText=" Please enter nominee name"
                                                    name="insuranceNomineeName"
                                                    handlerOnChange={(e) => {
                                                        // this.handleOnChange(e);
                                                        this.setLeadError(
                                                            this.utils.formValidation(
                                                                {
                                                                    ...this
                                                                        .lead,
                                                                },
                                                                [
                                                                    V.insuranceNomineeName,
                                                                ]
                                                            )
                                                        );
                                                    }}
                                                    value={
                                                        this.lead
                                                            .insuranceNomineeName
                                                    }
                                                    errorClass="input-info-fix"
                                                />
                                            </div>

                                            <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                                <SelectForm
                                                    title="Relation to Applicant"
                                                    noneText="Select Relation to Applicant"
                                                    errorText="Please select relation to applicant"
                                                    options={Relation}
                                                    name="insuranceNomineeRelation"
                                                    handlerOnChange={(e) =>
                                                        // this.handleOnChange(e);
                                                        this.setLeadError(
                                                            this.utils.formValidation(
                                                                {
                                                                    ...this
                                                                        .lead,
                                                                },
                                                                [
                                                                    V.insuranceNomineeRelation,
                                                                ]
                                                            )
                                                        )
                                                    }
                                                    value={
                                                        this.lead
                                                            .insuranceNomineeRelation
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                </div>
                <div className="relative w-full my-8">
                    <p className="grayshade-2 openSans-Reg text-base sm:text-lg md:text-xl mr-3 md:mr-4 mr-5 w-full">
                        Total Loan Amount
                    </p>
                    <div className="w-full openSans-SemiBold">
                        <span className="text-2xl lg:text-4xl WebRupee">
                            Rs.
                        </span>
                        <p className="text-base text-2xl lg:text-4xl ml-2 leading-normal inline-block">
                            {this.utils.currencyFormat(
                                this.lead.totalLoanAmount
                            )}
                        </p>
                    </div>
                </div>
                {/* <!-- Sarv Suraksha Insurance Popup Start --> */}
                {this.state.sarvSurakshaPopupSwitch ? (
                    <ModalPopUp
                        onclickhandler={() =>
                            this.setState({
                                sarvSurakshaPopupSwitch: false,
                            })
                        }
                    >
                        <LoanSarvSuraksha />
                    </ModalPopUp>
                ) : (
                    ""
                )}
                {/* <!-- Sarv Suraksha Insurance Popup End --> */}
            </>
        );
    }
}

export default LoanDetailsForm;
